var map = {
	"./step_pending_1.svg": 87624,
	"./step_pending_2.svg": 38363,
	"./step_pending_3.svg": 77994,
	"./step_pending_4.svg": 1205,
	"./step_pending_5.svg": 28596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53551;